import React, { memo } from 'react'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import StarIcon from '@mui/icons-material/Star'
import Rating from '@mui/material/Rating'
import Image from 'components/shared/Image'
import sx from './styles'

const Reviews = ({ item }) => {
  return (
    <Card
      sx={sx.root}
      elevation={2}
    >
      <CardHeader
        sx={{
          position: 'relative',
        }}
        avatar={
          (
            <Image
              sx={sx.image}
              alt={`avatar-${item.name}`}
              src={item.profile_photo_url}
              width={50}
              height={50}
              layout="fill"
              objectFit="contain"
              blurDataURL={item.profile_photo_url}
              placeholder="blur"
            />
          )
        }
        title={item.author_name}
        subheader={item.relative_time_description}
      />
      <CardContent>
        <Rating
          sx={sx.rating}
          value={item.rating}
          readOnly
          precision={0.5}
          size="small"
          emptyIcon={(
            <StarIcon
              style={{ opacity: 1 }}
              fontSize="inherit"
            />
          )}
        />
        <Typography
          variant="body2"
          sx={sx.text}
        >
          {item.text}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default memo(Reviews)
